import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SmartAssistant.scss";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

function ChatGPT() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const savedMessages = localStorage.getItem("chatMessages");
    if (savedMessages) setMessages(JSON.parse(savedMessages));
  }, []);

  useEffect(() => {
    localStorage.setItem("chatMessages", JSON.stringify(messages));
  }, [messages]);

  // ✅ IMPORTANT: PAS DE DOUBLONS ICI
  const customResponses = {
    // =========================
    // PRÉSENTATION
    // =========================
    "t'es qui toi ?":
      "Je suis AKAMIBOT 🤖, l’assistant intelligent du site d’Akami Mehdi. Je suis là pour vous guider et vous aider à concrétiser vos projets.",
    "t es qui toi":
      "Je suis AKAMIBOT 🤖, l’assistant intelligent du site d’Akami Mehdi. Je suis là pour vous guider et vous aider à concrétiser vos projets.",
    "qui es tu":
      "Je suis AKAMIBOT 🤖, un assistant virtuel conçu pour répondre à vos questions et vous orienter vers les bons services.",
    "c'est quoi akamibot":
      "AKAMIBOT est l’assistant IA officiel de Mehdi Akami, spécialisé en développement web, WordPress, React et QA.",

    // =========================
    // À PROPOS
    // =========================
    "qui est mehdi akami":
      "Mehdi Akami est un développeur full stack et testeur QA, spécialisé dans la création de solutions web fiables et performantes.",
    "c'est qui mehdi akami ?":
      "Mehdi Akami est un professionnel du web avec une forte expertise en développement, intégration et assurance qualité.",
    "c qui akami mehdi":
      "Akami Mehdi est un développeur orienté qualité, performance et expérience utilisateur.",

    // =========================
    // SERVICES
    // =========================
    "quels services proposes tu":
      "Développement web, intégration front-end, React, WordPress, tests QA et solutions digitales sur mesure.",
    "tu proposes quoi comme service":
      "Création de sites web, applications React, tests logiciels, automatisation QA et accompagnement technique.",
    "que sais tu faire":
      "Je peux vous informer sur les services, les projets réalisés et vous guider pour démarrer une collaboration.",

    // =========================
    // CLIENTS / CONVERSION
    // =========================
    "je veux un site web":
      "Très bon choix 👍 Mehdi peut créer un site moderne, rapide et adapté à vos besoins. Vous voulez un site vitrine ou une application web ?",
    "je cherche un developpeur":
      "Vous êtes au bon endroit ✅ Mehdi Akami peut vous accompagner de l’idée jusqu’à la mise en ligne.",
    "je cherche un testeur qa":
      "Mehdi Akami est spécialisé en tests logiciels, validation fonctionnelle et assurance qualité.",
    "j'ai un projet": `
Excellente nouvelle 🚀<br/>
Décrivez votre besoin via la page contact :<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Lancer mon projet</a>
`,

    // =========================
    // PRIX / DEVIS (HTML cliquable)
    // =========================
    "je veux un devis": `
Pour un devis personnalisé 📄 :<br/>
📞 <strong>0699858005</strong><br/>
📧 <strong>akamimehdi.dev@gmail.com</strong><br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Accéder à la page Contact</a>
`,
    "je veux un prix": `
Les tarifs dépendent de votre projet (site web, QA, WordPress, React).<br/>
📞 0699858005<br/>
📧 akamimehdi.dev@gmail.com<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Demander un devis</a>
`,
    "combien ça coûte": `
Chaque projet est unique.<br/>
👉 Contact direct :<br/>
📞 0699858005<br/>
📧 akamimehdi.dev@gmail.com<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Page Contact</a>
`,
    "tarif": `
Pour un tarif exact il faut le détail du besoin.<br/>
📞 0699858005<br/>
📧 akamimehdi.dev@gmail.com<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Demander un devis</a>
`,

    // =========================
    // CONTACT
    // =========================
    "comment te contacter": `
📞 0699858005<br/>
📧 akamimehdi.dev@gmail.com<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Formulaire de contact</a>
`,
    "contact": `
📞 0699858005<br/>
📧 akamimehdi.dev@gmail.com<br/>
🔗 <a href="https://akamimehdi.netlify.app/Contact" target="_blank" rel="noopener noreferrer">Page Contact</a>
`,

    // =========================
    // POLI / HUMAIN
    // =========================
    bonjour: "Bonjour 👋 Je suis AKAMIBOT. Comment puis-je vous aider ?",
    salut: "Salut 👋 Besoin d’une info ou d’un devis ?",
    merci: "Avec plaisir 😊 N’hésitez pas si vous avez d’autres questions.",
    "ça va": "Oui merci 😊 Et vous ?",
  };

  const normalize = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ")
      .replace(/[’']/g, "'"); // uniformiser apostrophes

  const handleSend = async () => {
    if (!input.trim()) return;

    const userText = input;
    const userMessage = { text: userText, sender: "user" };
    const nextMessages = [...messages, userMessage];

    setMessages(nextMessages);
    setInput("");

    const key = normalize(userText);

    // ✅ réponses locales
    if (customResponses[key]) {
      setMessages((prev) => [
        ...prev,
        { text: customResponses[key], sender: "bot", isCode: false },
      ]);
      return;
    }

    // ✅ sinon: Gemini via Netlify Function
    try {
      const response = await axios.post(
        "/.netlify/functions/gemini",
        {
          messages: nextMessages,
          input: userText,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const botText = (response.data?.text || "").trim();

      if (!botText) {
        setMessages((prev) => [
          ...prev,
          { text: "Désolé, je n’ai pas reçu de réponse. Réessaie.", sender: "bot", isCode: false },
        ]);
        return;
      }

      const isCode = botText.startsWith("```") && botText.endsWith("```");

      setMessages((prev) => [
        ...prev,
        { text: botText.replace(/```/g, ""), sender: "bot", isCode },
      ]);
    } catch (error) {
      console.error("Erreur Gemini (Netlify Function):", error);
      setMessages((prev) => [
        ...prev,
        {
          text: "🧠 Pause café pour AKAMIBOT ☕Les quotas se remettent en place, patience 😄",
          sender: "bot",
          isCode: false,
        },
      ]);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chatgpt-page" style={{ minHeight: "50vh", width: "100%" }}>
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: "-1",
          borderRadius: "10px",
        }}
      >
        <source
          src="/images/videos/5818973-uhd_3840_2160_24fps.mp4"
          type="video/mp4"
        />
        Votre navigateur ne supporte pas la lecture vidéo.
      </video>

      <div
        style={{
          zIndex: "1",
          padding: "20px",
          boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
          borderRadius: "10px",
        }}
      >
        <div className="chatgpt">
          <h1>{t("chatgpt.welcomeMessage")}</h1>

          <div className="chat-window">
            {messages.length === 0 ? (
              <div className="welcome-message">
                <p>{t("chatgpt.greeting")}</p>
                <p>{t("chatgpt.helpPrompt")}</p>
                <p>{t("chatgpt.suggestion")}</p>
                <ul>
                  <li>🎓 {t("chatgpt.example1")}</li>
                  <li>📈 {t("chatgpt.example2")}</li>
                  <li>💡 {t("chatgpt.example3")}</li>
                </ul>
              </div>
            ) : (
              messages.map((msg, index) => (
                <div
                  key={index}
                  className={`message ${msg.sender} ${msg.isCode ? "code-block" : ""}`}
                >
                  {msg.isCode ? (
                    <pre>
                      <code>{msg.text}</code>
                    </pre>
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                  )}
                </div>
              ))
            )}
          </div>

          <div className="input-area">
            <textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder={t("chatgpt.inputPlaceholder")}
              rows="1"
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = e.target.scrollHeight + "px";
              }}
            />
            <div className="icon-container" onClick={handleSend}>
              <FontAwesomeIcon icon={faPaperPlane} className="icon-send" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatGPT;
